module.exports = __webpack_public_path__ + "static/US2_traditional_v2-2d3c56ccb64cf0a41c41504391f12c81.png";